import { render } from "./AdminProductsManage.vue?vue&type=template&id=d1c4cce0"
import script from "./AdminProductsManage.vue?vue&type=script&lang=js"
export * from "./AdminProductsManage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__